export const checksums = {
  "home": "v3.5.0--qiiWIVP1Bck8r3-6oj6wrRtY1434J8-9yimBHRXmejU",
  "about": "v3.5.0--suwkTi4jmic1rKXq22XseWmsTY0DRBhGkjSzxBDI2-s",
  "projects": "v3.5.0--prn5a-cW2APR5kdga5JYak2jf680MTjZlZvwFF26wC8",
  "articles": "v3.5.0--BAO9gP8FkFmIv6LKOwjTmoQJdq3td5E9GmJ7S4-I4Io"
}
export const checksumsStructure = {
  "home": "6tjAi7ebSBfroktThBIYkCKmI7Y5aQCsvFJELC_R4_4",
  "about": "gQlnztJ3OsmJMEC1LkIO-FYopBrbkTVuhw_3Z2zQMv4",
  "projects": "llkSutxihWLJQsYjTIdH3Q1H3kGaDJAtEuM702CgoTQ",
  "articles": "tt51nbHszjr4GBUsTe0vzVkNJQkIOA8k6Xv0oYolvf0"
}

export const tables = {
  "home": "_content_home",
  "about": "_content_about",
  "projects": "_content_projects",
  "articles": "_content_articles",
  "info": "_content_info"
}

export default {
  "home": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "skillGroups": "json",
      "socials": "json",
      "stem": "string",
      "tags": "json"
    }
  },
  "about": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "experiences": "json",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "projects": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "cover": "string",
      "date": "date",
      "demo": "string",
      "description": "string",
      "extension": "string",
      "github": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "period": "string",
      "seo": "json",
      "slug": "string",
      "stem": "string",
      "tags": "json"
    }
  },
  "articles": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "date": "date",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "slug": "string",
      "stem": "string",
      "tags": "json"
    }
  },
  "info": {
    "type": "data",
    "fields": {}
  }
}